import { render, staticRenderFns } from "./WorkspaceExpressionFilterControls.vue?vue&type=template&id=1766c078&scoped=true"
import script from "./WorkspaceExpressionFilterControls.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpressionFilterControls.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpressionFilterControls.vue?vue&type=style&index=0&id=1766c078&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766c078",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1766c078')) {
      api.createRecord('1766c078', component.options)
    } else {
      api.reload('1766c078', component.options)
    }
    module.hot.accept("./WorkspaceExpressionFilterControls.vue?vue&type=template&id=1766c078&scoped=true", function () {
      api.rerender('1766c078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpressionFilterControls.vue"
export default component.exports